import { observer } from 'mobx-react';

import { OnOffEnum } from '@/constants/enums';
import { DeviceType } from '@/constants/deviceTypeEnum';
import { FooterContainer } from './Footer.styles';
import StartStopButtons from './StartStopButtons/StartStopButtons';
import MaintenanceToggle from './MaintenanceToggle/MaintenanceToggle';

interface FooterProps {
  inMaintenance: boolean;
  poweredOn: OnOffEnum;
  deviceId: string;
  deviceType: DeviceType;
}

const Footer = observer(({ inMaintenance, deviceId, deviceType, poweredOn }: FooterProps) => {
  return (
    <FooterContainer>
      <StartStopButtons deviceId={deviceId} deviceType={deviceType} poweredOn={poweredOn} />
      <MaintenanceToggle deviceId={deviceId} inMaintenance={inMaintenance} />
    </FooterContainer>
  );
});

export default Footer;
